export enum SnsTopicStatus {
  CONFIRMED = 'Akzeptiert',
  DELETED = 'Gelöscht',
  PENDINGCONFIRMATION = 'Ausstehend',
}
